import {register} from "../../redux/user/actions";

import AuthLayout from "../../layouts/AuthLayout";

const Register = () => {
    return <AuthLayout onSubmitAction={register} forRegister/>;
};

export default Register;